const CARD_HEIGHT = 550;
const CARD_WIDTH_DESKTOP = 500;
const CARD_WIDTH_MOBILE = 350;
const CARD_WIDTH = { xs: CARD_WIDTH_MOBILE, md: CARD_WIDTH_DESKTOP };

const CARD_MEDIA_HEIGHT = 350;

export { CARD_HEIGHT, CARD_MEDIA_HEIGHT, CARD_WIDTH, CARD_WIDTH_DESKTOP, CARD_WIDTH_MOBILE };
